var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-embed',{attrs:{"type":"embed","aspect":"1by1","src":'https://live-scotswim-full.ocs-software.com/dynamic-forms/?form_id=' + _vm.page[0].acf.form.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }